@import 'src/styles/common/_colors.scss';
.xAxis path {
	display: none;
}

.circle {
    &:hover {
        r: 4;
    }
    position: relative;
}

.major line {
	stroke: #a8a8a8;
	stroke-width: 1px;
}

.major path, .minor path {
	display: none;
}

.minor line {
	stroke: #515151;
	stroke-width: 1px;
}

.symbol {
    fill: $white;
    font-weight: bold;
}

.greyLine {
    fill: #3a3a3a;
    stroke: #3a3a3a;
    stroke-width: 1;
}